import React from 'react';

import { Dialog } from '@buildoutinc/blueprint-react/ui/Dialog';
import Button from 'shared/button';

interface Props {
  show: boolean;
  onDelete: () => void | Promise<void>;
  onHide: () => void;
}

export default function DeleteModal({ show, onDelete, onHide }: Props) {
  async function handleDelete() {
    await onDelete();
    onHide();
  }

  const handleOpenChange = (open: boolean) => {
    if (!open) onHide();
  };

  return (
    <Dialog open={show} onOpenChange={handleOpenChange}>
      <Dialog.Content>
        <Dialog.Header>
          <Dialog.Title>Delete Task</Dialog.Title>
        </Dialog.Header>
        <Dialog.Body>
          <p>Are you sure you want to delete this task?</p>
        </Dialog.Body>
        <Dialog.Footer>
          <Dialog.Cancel>Cancel</Dialog.Cancel>
          <Button.Danger onClick={handleDelete}>Delete</Button.Danger>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  );
}
